import { useMemo } from 'react';
import useSWR from 'swr';
import api from '../../../services/api';
import { authService } from '../../../services/authService';
import { moduleManagementConfig } from './config';

export type ModuleEntitlements = Record<string, boolean>;

const ENTITLEMENTS_KEY = moduleManagementConfig.api.entitlements;

const EMPTY_ENTITLEMENTS: ModuleEntitlements = {};

export const useModuleEntitlements = () => {
  const token = authService.getToken();
  const { data, error, isLoading, mutate } = useSWR<ModuleEntitlements>(
    token ? ENTITLEMENTS_KEY : null,
    (url: string) => api.get(url).then((r) => r.data),
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  const updateEntitlements = async (entitlements: Record<string, boolean>) => {
    const updated = await api
      .patch<ModuleEntitlements>(ENTITLEMENTS_KEY, { entitlements })
      .then((r) => r.data);
    await mutate(updated, false);
    return updated;
  };

  const entitlements = useMemo(() => data ?? EMPTY_ENTITLEMENTS, [data]);

  return {
    entitlements,
    isLoading,
    isError: error,
    mutate,
    updateEntitlements,
  };
};
